import { useEffect, useState } from "react";
import { PartyPopper } from "lucide-react";
import { api } from "@/lib/api";

export const MilestoneShoutouts = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/milestones/recent").then((r) => setItems(r.data)).catch(() => {}); }, []);
  if (!items.length) return null;
  return (
    <section data-testid="milestone-shoutouts" className="rounded-2xl border-2 border-amber-400/70 bg-amber-400/10 p-4">
      <div className="flex items-center gap-2 text-sm font-extrabold text-amber-300"><PartyPopper className="h-5 w-5" /> Well done! New milestones in the last 2 weeks</div>
      <div className="mt-3 flex flex-wrap gap-2">
        {items.slice(0, 12).map((e, i) => (
          <span key={`${e.user_id}-${e.label}-${i}`} data-testid={`shoutout-${i}`} className="rounded-full bg-amber-400 px-3 py-1 text-xs font-bold text-black">
            {e.rider_name} · {e.label}
          </span>
        ))}
      </div>
    </section>
  );
};

export const MyNewBadges = ({ labels }) => {
  if (!labels?.length) return null;
  return (
    <div data-testid="my-new-badges" className="flex items-center gap-3 rounded-2xl border-2 border-amber-400/70 bg-amber-400/10 p-4 text-sm font-bold text-amber-300">
      <PartyPopper className="h-6 w-6 shrink-0" /> Well done! You've earned: {labels.join(", ")}
    </div>
  );
};
